const CartStyles = {
    baseStyle: {
        cartContainer: {
            maxWidth: {base: '100%', xl: '1440px'},
            backgroundColor: 'white',
            padding: {
                base: '0px 15px 30px 15px',
                lg: '30px 20px',
                '2lg': '30px 60px'
            }
        },
        lineItems: {
            item: {
                name: {
                    color: 'black.100',
                    fontFamily: 'heading',
                    fontSize: '20px',
                    fontWeight: '400',
                    letterSpacing: '0.1px',
                    transition: 'color 0.3s ease',
                    _hover: {
                        textDecoration: 'unset',
                        color: 'blue.700'
                    }
                },
                imageBox: {
                    base: {
                        margin: '0px',
                        display: 'inline-flex'
                    },
                    image: {
                        width: {base: '140px', lg: '180px'},
                        height: {base: '175px', lg: '225px'},
                        minWidth: {base: '140px', lg: '180px'},
                        mixBlendMode: 'multiply',
                        aspectRatio: '180/225'
                    }
                },
                imageWrapper: {
                    position: 'relative',
                    backgroundColor: 'gray.100',
                    minHeight: {base: '175px', lg: '225px'},
                    minWidth: {base: '140px', lg: '180px'}
                },
                namePriceStack: {
                    base: {
                        gap: '10px',
                        display: 'inline-flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                    }
                },
                nameVariation: {
                    gap: '10px',
                    display: 'grid'
                },
                productOptions: {
                    fontSize: '14px',
                    fontWeight: '300',
                    color: 'black.100',
                    maxWidth: '495px',
                    lineHeight: '22px'
                },
                nameWrapper: {
                    base: {
                        justifyContent: 'space-between',
                        gap: {base: '10px', lg: '10px'},
                        display: 'grid'
                    },
                    price: {
                        width: 'fit-content',
                        display: {
                            lg: 'grid'
                        },
                        sx: {
                            '.list-price': {
                                color: 'gray.650 !important',
                                fontWeight: '300',
                                letterSpacing: '0.07px',
                                lineHeight: '22px'
                            },
                            '.current-price': {
                                fontWeight: '700',
                                lineHeight: '22px',
                                color: 'black.100 !important',
                                letterSpacing: '0.07px',
                                fontSize: '14px'
                            }
                        }
                    }
                },
                variationsWrapper: {
                    text: {
                        color: 'black.100',
                        width: 'fit-content',
                        fontSize: '14px',
                        fontWeight: '300',
                        lineHeight: '22px',
                        letterSpacing: '0.07px'
                    }
                },
                itemStack: {
                    width: '100%',
                    gap: '20px'
                },
                inventoryMessage: {
                    color: 'red.950',
                    fontWeight: '300',
                    fontSize: '13px',
                    lineHeight: '22px',
                    letterSpacing: '0.065px'
                },
                bopisNotAvailable: {
                    color: 'red.400',
                    display: 'inline-block',
                    fontFamily: 'body',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '25px',
                    letterSpacing: '0.07px'
                },
                bopisNotAvailableBlackText: {
                    color: 'gray.650',
                    display: 'block',
                    fontSize: '12px',
                    fontWeight: '300',
                    lineHeight: '20px',
                    letterSpacing: '0.06px'
                },
                bopisNotAvailableInStore: {
                    color: 'red.950',
                    fontFamily: 'body',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '300',
                    lineHeight: '25px',
                    letterSpacing: '0.07px',
                    margin: '10px 0 0 25px'
                },
                totalMarkdownPrice: {
                    fontSize: '10px',
                    fontWeight: '300',
                    color: 'green.720',
                    letterSpacing: '0.05px',
                    lineHeight: '25px'
                },
                threeTierdPricing: {
                    fontSize: '10px',
                    color: 'gray.800',
                    fontWeight: '300',
                    letterSpacing: '0.05px',
                    lineHeight: '25px'
                },
                itemFlex: {
                    width: '100%',
                    gap: {base: '10px', md: '20px'}
                },
                quantityWrapper: {
                    buttons: {
                        height: '40px',
                        width: '25px',
                        borderColor: 'gray.600',
                        padding: '0px 7px',
                        minWidth: 'auto',
                        _hover: {
                            background: 'white'
                        }
                    },
                    input: {
                        height: '40px',
                        width: '40px',
                        borderColor: 'gray.600',
                        borderLeft: '0px',
                        borderRight: '0px',
                        borderRadius: '0px',
                        _hover: {
                            borderColor: 'gray.600'
                        },
                        _focus: {
                            borderColor: 'gray.600'
                        },
                        _focusVisible: {
                            boxShadow: 'unset'
                        },
                        fontSize: '16px',
                        color: 'black.100',
                        fontWeight: '300',
                        letterSpacing: '0.08px',
                        lineHeight: '25px'
                    }
                },
                secondaryButtons: {
                    fontSize: '14px',
                    fontWeight: '300',
                    height: 'fit-content',
                    margin: '0px !important',
                    letterSpacing: '0.07px',
                    lineHeight: '22px',
                    textDecoration: 'underline',
                    textUnderlineOffset: '4px',
                    color: 'black.100',
                    transition: 'color 0.3s ease',
                    _hover: {
                        color: 'blue.700'
                    }
                },
                engravingGrid: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    gap: '5px'
                },

                engravingCell: {
                    base: {
                        width: '67px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        mb: '12px'
                    },
                    single: {
                        width: '100%'
                    }
                },

                engravingImageWrapper: {
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: 'gray.100'
                },
                engravingImage: {
                    width: '67px',
                    height: '84px',
                    objectFit: 'contain',
                    mixBlendMode: 'multiply'
                },
                engravingHeading: {
                    fontSize: '16px',
                    fontWeight: '400',
                    fontFamily: 'heading',
                    letterSpacing: '0.08px',
                    margin: '10px 0',
                    color: 'black.100'
                },
                engravingLabel: {
                    fontSize: '13px',
                    fontFamily: 'body',
                    color: 'black.100',
                    fontWeight: '300'
                },
                giftCert: {
                    price: {
                        color: 'black.100',
                        fontFamily: 'body',
                        fontSize: '14px',
                        fontWeight: '700'
                    },
                    deliveryLabel: {
                        color: 'black.100',
                        fontFamily: 'body',
                        fontSize: '13px',
                        fontWeight: '300',
                        margin: '10px 0'
                    },
                    toFrom: {
                        color: 'black.100',
                        fontFamily: 'body',
                        fontSize: '13px',
                        fontWeight: '700',
                        marginRight: '5px'
                    },
                    recipientSender: {
                        color: 'black.100',
                        fontFamily: 'body',
                        fontSize: '13px',
                        fontWeight: '300',
                        marginRight: '5px'
                    },
                    recipientEmail: {
                        display: {base: 'block', lg: 'inline-block'},
                        color: 'black.100',
                        fontFamily: 'body',
                        fontSize: '13px',
                        fontWeight: '300',
                        marginRight: '5px'
                    }
                }
            }
        },
        checkoutSummarylineItems: {
            giftcertImage: {
                width: '120px',
                height: '150px'
            },
            imageWrapper: {
                minWidth: '120px',
                minHeight: '150px'
            },
            giftcertName: {
                color: 'black.100',
                fontSize: '18px',
                fontWeight: '400',
                lineHeight: 'normal',
                letterSpacing: '0.09px'
            },
            giftcertQuantity: {
                fontFamily: 'body',
                color: 'black.100',
                fontWeight: '300',
                fontSize: '14px'
            },
            giftcertPrice: {
                fontFamily: 'body',
                color: 'black.100',
                fontWeight: '400',
                fontSize: '14px'
            }
        },
        mobileOrderSummaryContainer: {
            display: {base: 'block', lg: 'none'},
            backgroundColor: 'gray.100',
            width: '100vw',
            margin: {base: '0 -15px', lg: '0'},
            padding: '0 15px',
            zIndex: '2',

            sticky: {
                position: 'sticky',
                top: '60px',
                boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.10)'
            },
            inline: {
                margin: {base: '0 -15px', lg: '0'}
            }
        },
        tncText: {
            padding: '0',
            fontSize: '13px',
            letterSpacing: '0.065px',
            color: 'black.100',
            fontFamily: 'body'
        },
        bonusProductsCallout: {
            background: 'green.150',
            color: 'black.100',
            borderWidth: '2px',
            borderStyle: 'solid',
            borderColor: 'green.700',
            borderRadius: '3px',
            padding: '10px 20px',
            height: 'auto',
            textAlign: 'left'
        },
        bonusProductsCalloutHeading: {
            fontFamily: 'heading',
            fontSize: '20px',
            fontWeight: '400',
            letterSpacing: '0.1px',
            lineHeight: 'normal',
            width: 'fit-content'
        },
        bonusProductsCalloutText: {
            fontFamily: 'body',
            fontSize: '13px',
            fontWeight: '300',
            letterSpacing: '0.065px',
            lineHeight: '22px'
        },
        cartEndorsementCallout: {
            mb: '10px',
            sx: {
                'a.cart-endorsement-callout': {
                    textDecoration: 'none !important',
                    color: 'inherit',
                    _hover: {textDecoration: 'none'}
                },
                '.cart-endorsement-callout': {
                    background: 'green.150',
                    borderRadius: '3px',
                    padding: {base: '16px 20px', lg: '27px 20px'},
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px'
                },
                '.callout-icon img': {
                    width: '29px',
                    height: '29px'
                },
                '.callout-content': {
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column'
                },
                '.callout-headline': {
                    fontFamily: 'heading',
                    fontSize: '20px',
                    fontWeight: '400',
                    lineHeight: 'normal',
                    color: 'black.100',
                    margin: 0
                },
                '.callout-body': {
                    fontFamily: 'body',
                    fontSize: '13px',
                    fontWeight: '300',
                    color: 'black.100',
                    lineHeight: '22px',
                    letterSpacing: '0.065px',
                    margin: 0
                },
                '.callout-link': {
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center'
                },
                '.callout-link img': {
                    width: '15px',
                    height: '15px'
                }
            }
        },
        wishlistInCart: {
            callout: {
                border: '1px solid',
                borderColor: 'gray.450',
                borderRadius: 'md',
                padding: 5,
                backgroundColor: 'gray.100'
            },
            preview: {
                backgroundColor: 'white',
                width: '100%',
                minWidth: 0,
                position: 'relative'
            },
            titleRow: {
                direction: 'row',
                align: 'center',
                marginBottom: 5,
                gap: 5,
                minHeight: '42px',
                paddingRight: '94px'
            },
            titleWithIcon: {
                align: 'center',
                gap: '15px',
                marginBottom: 2.5
            },
            titleIcon: {
                as: 'span',
                fontSize: 'lg',
                color: 'gray.800',
                lineHeight: '1'
            },
            title: {
                as: 'h2',
                fontSize: '30px',
                fontWeight: 'normal',
                letterSpacing: '0.15px',
                color: 'gray.800',
                fontFamily: 'heading'
            },
            bodyText: {
                fontFamily: 'inter',
                fontSize: '14px',
                fontWeight: '300',
                lineHeight: '22px',
                letterSpacing: '0.07px',
                color: 'black.100'
            },
            inlineLink: {
                textDecoration: 'underline',
                _hover: {color: 'black'}
            },
            viewAllLink: {
                fontSize: '13px',
                fontFamily: 'inter',
                fontWeight: '300',
                letterSpacing: '0.065px',
                color: 'black.100',
                textDecoration: 'underline',
                textDecorationStyle: 'solid',
                textDecorationThickness: 'auto',
                textUnderlineOffset: 'auto',
                textUnderlinePosition: 'from-font',
                sx: {textDecorationSkipInk: 'none'}
            },
            emptyStateAsset: {
                sx: {
                    '.wishlist-heading': {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '15px'
                    },
                    '.wishlist-heading h2': {
                        fontSize: '30px',
                        fontWeight: 'normal',
                        letterSpacing: '0.15px',
                        color: 'gray.800',
                        fontFamily: 'heading'
                    },
                    '& p': {
                        fontFamily: 'inter',
                        fontSize: '14px',
                        fontWeight: '300',
                        lineHeight: '22px',
                        letterSpacing: '0.07px',
                        color: 'black.100'
                    },
                    '& a': {
                        textDecoration: 'underline',
                        cursor: 'pointer'
                    },
                    '& a:hover': {
                        color: 'blue.700'
                    }
                }
            },
            carouselWrapper: {
                position: 'static',
                width: '100%',
                overflow: 'hidden',
                minWidth: 0,
                sx: {
                    '.swiper': {
                        position: 'static'
                    },
                    '.swiper-button-next, .swiper-button-prev': {
                        top: '0 !important',
                        opacity: '1 !important',
                        display: 'flex !important',
                        boxShadow: 'none !important',
                        backgroundColor: 'transparent !important',
                        '&:hover': {
                            backgroundColor: 'transparent !important'
                        },
                        '&.swiper-button-disabled': {
                            opacity: '0.35 !important',
                            display: 'flex !important'
                        }
                    },
                    '.swiper-button-next': {
                        right: '-10px !important',
                        left: 'initial !important'
                    },
                    '.swiper-button-prev': {
                        right: '37px !important',
                        left: 'initial !important'
                    }
                }
            },
            item: {
                wrapper: {
                    flexShrink: 0,
                    width: '175px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px'
                },
                imageWrapper: {
                    flexShrink: 0,
                    width: '175px',
                    height: '250px',
                    borderRadius: 'sm',
                    overflow: 'hidden',
                    backgroundPosition: '50%',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundBlendMode: 'multiply'
                },
                name: {
                    fontSize: '18px',
                    fontFamily: 'heading',
                    fontWeight: 'normal',
                    lineHeight: 'normal',
                    flex: '1',
                    color: 'black',
                    letterSpacing: '0.09px'
                },
                price: {
                    fontSize: '16px',
                    fontWeight: '300',
                    color: 'black',
                    lineHeight: '25px',
                    fontFamily: 'inter',
                    letterSpacing: '0.08px'
                },
                button: {
                    variant: 'outline',
                    fontSize: '13px',
                    height: '26px',
                    fontFamily: 'inter',
                    width: '100%',
                    lineHeight: '22px',
                    letterSpacing: '0.065px',
                    color: 'black.100',
                    borderColor: 'gray.450',
                    borderRadius: '90px',
                    fontWeight: '300'
                }
            }
        },
        emptyCart: {
            actionButtons: {
                width: '257px',
                height: '56px',
                fontSize: '17px',
                fontWeight: '400',
                lineHeight: '26px',
                letterSpacing: '0.085px',
                textDecoration: 'unset !important'
            },
            signInButton: {
                backgroundColor: 'white',
                _hover: {
                    backgroundColor: 'gray.425 !important'
                },
                color: 'black.100'
            }
        },
        deliveryMethod: {
            title: {
                fontFamily: 'Cormorant',
                fontSize: '30px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: 'normal',
                color: 'black.100',
                letterSpacing: '0.15px'
            },
            container: {
                display: 'flex',
                gap: '15px',
                flexDirection: 'column',
                padding: {base: '-15px', lg: '0px 15px'}
            },
            deliveryOptions: {
                display: 'flex',
                background: 'gray.100',
                padding: '5px',
                borderRadius: '10px',
                sx: {
                    'a:hover': {
                        textDecoration: 'none'
                    }
                }
            },
            deliveryOptionText: {
                display: 'flex',
                flex: '1',
                justifyContent: 'center',
                color: 'gray.800',
                fontFamily: 'Inter',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: '700',
                lineHeight: '20px',
                letterSpacing: '0.06px',
                padding: '8px 20px',
                borderRadius: '5px'
            },
            deliveryOptionTextSelected: {
                background: 'gray.400',
                color: 'black.100'
            },
            deliveryDetailsContainer: {
                borderRadius: '10px',
                border: '1px solid',
                borderColor: 'gray.400',
                padding: '20px'
            },
            deliveryDetails: {
                wrapper: {
                    display: 'flex',
                    alignItems: 'center'
                },
                image: {
                    marginRight: '10px'
                },
                delivery: {
                    color: 'black.100',
                    fontFamily: 'Inter',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: '22px',
                    letterSpacing: '0.065px',
                    marginRight: '20px'
                },
                noDeliverySelectedLabel: {
                    color: 'gray.800',
                    fontFamily: 'Inter',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: '300',
                    lineHeight: '22px',
                    letterSpacing: '0.065px'
                },
                bopis: {
                    display: 'flex',
                    gap: 'auto',
                    justifyContent: 'space-between',
                    alignItems: 'start'
                },
                imageTextWrapper: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'start'
                },
                bopisText: {
                    display: 'flex',
                    width: '185px',
                    flexDirection: 'column'
                },
                textLabel: {
                    color: 'black.100',
                    fontFamily: 'Inter',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: '300',
                    lineHeight: '22px',
                    letterSpacing: '0.065px',
                    maxWidth: {base: '200px', sm: '100%'}
                },
                textLabelNotAvailable: {
                    color: 'red.400',
                    fontFamily: 'Inter',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    fontWeight: '300',
                    lineHeight: '22px',
                    letterSpacing: '0.065px',
                    maxWidth: {base: '200px', sm: '100%'}
                },
                selectedStore: {
                    color: 'black.100',
                    fontFamily: 'Inter',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: '700',
                    lineHeight: '22px',
                    letterSpacing: '0.065px',
                    textTransform: 'capitalize'
                },
                changeStore: {
                    color: 'black.100',
                    fontFamily: 'Inter',
                    fontSize: '13px',
                    fontStyle: 'normal',
                    fontWeight: '300',
                    lineHeight: '22px',
                    letterSpacing: '0.065px',
                    textDecoration: 'underline',
                    textUnderlineOffset: '4px',
                    _hover: {
                        cusor: 'pointer'
                    }
                }
            }
        },
        boxStyles: {
            bg: 'gray.100',
            p: '15px 30px',
            textAlign: 'center',
            borderRadius: '10px',
            border: '1px solid',
            borderColor: 'gray.450',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: '400',
            gap: '15px',
            flexDirection: {base: 'column', md: 'row'}
        },
        titleTextStyles: {
            as: 'p',
            color: 'purple.700',
            fontSize: '20px',
            fontFamily: 'heading',
            m: '0'
        },
        preorderBagStyles: {
            as: 'span',
            color: 'purple.700',
            fontSize: '14px',
            fontFamily: 'body',
            p: '4px 25px',
            borderRadius: '90px',
            display: 'flex',
            gap: '10px',
            bg: 'purple.75',
            alignItems: 'center',
            whiteSpace: 'nowrap',
            fontWeight: '400',
            cursor: 'pointer'
        },
        acceptedPaymentMethods: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px'
        },
        acceptedPaymentMethodsLabel: {
            fontFamily: 'caslon',
            fontSize: '15px',
            fontWeight: '500',
            color: '#746D63'
        },
        acceptedPaymentMethodsIconsContainer: {
            flexWrap: 'wrap',
            justifyContent: {base: 'flex-start', md: 'center', lg: 'flex-start'},
            gap: '10px',
            width: '100%',
            border: '1px solid',
            borderColor: '#EDE8E3',
            borderRadius: '5px',
            padding: '10px'
        },
        acceptedPaymentMethodsIcon: {
            width: '55px',
            height: '32px'
        }
    }
}

export default CartStyles
